import React, { createContext, useState, useEffect } from "react";
import { addDays } from "date-fns";
export const MyContext = createContext();

const MyProvider = ({ children }) => {
  const [toggleButton, settoggleButton] = useState(false);
  const [toggleAdduser, settoggleAdduser] = useState(false);
  const [serverresponses, setServerResponses] = useState(null);
  const [fromDateTime, setFromDateTime] = useState(null);
  const [toDateTime, setToDateTime] = useState(null);

  const [pdfToSimple, setpdfToSimple] = useState(null);
  const [pdfFromSimple, setpdfFromSimple] = useState(null);
  const [analyticsData, setAnalyticsData] = useState(null);
  const [serverresponse, setServerResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const [apiSelect, setAPISelect] = useState({
    value: "api/filter",
    label: "Social Media Report",
  });

  // New state variables
  const [selectedPlatforms, setSelectedPlatforms] = useState([]);
  const [selectedKeyword, setSelectedKeyword] = useState([]);
  const [selectedSections, setSelectedSections] = useState([]);
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [selectedSentiment, setSelectedSentiment] = useState([]);
  const [selectedIntensity, setSelectedIntensity] = useState(null);
  const [selectedContent, setSelectedContent] = useState([]);
  const [fromDateTimeFormatted, setFromDateTimeFormatted] = useState(null);
  const [toDateTimeFormatted, setToDateTimeFormatted] = useState(null);
  const [responseCount, setResponseCount] = useState(0);
  const [filteredCrawledData, setfilteredCrawledData] = useState([]);
  const [togglefilteredCrawledData, settogglefilteredCrawledData] =
    useState(false);
  const [keywordInput, setKeywordInput] = useState("");
  const [isSubMenuOpenDataHub, setIsSubMenuOpenDataHub] = useState(false);

  const [sidebarPlatformName, setsidebarPlatformName] = useState("");
  // karan
  const [selectedPlatform, setSelectedPlatform] = useState("All");
  const [currentPage, setCurrentPage] = useState(1);

  const [isLoadings, setIsLoadings] = useState(true);
  const [viewMode, setViewMode] = useState("Session Records"); // New state for view mode
  const [selectedPlatformss, setselectedPlatformss] = useState([]);
  const [postCount, setPostCount] = useState("100");
  const [isSpecificDateEnabled, setIsSpecificDateEnabled] = useState(false);
  const [dateWiseData, setDateWiseData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [sessionData, setsessionData] = useState([]);
  const [data, setData] = useState([]);
  const [itemsPerPage] = useState(10);
  const [AnalysisSessionData, setAnalysisSessionData] = useState([]);
  const [updateStatus, setupdateStatus] = useState("");
  const [availablePlatforms, setAvailablePlatforms] = useState([]);
  const [navigationCount, setNavigationCount] = useState(0);
  const [loading, setLoading] = useState(false); // Add loading state
  const [NewsCount, setNewsCount] = useState({});
  const [allCrawledData, setallCrawledData] = useState([]);
  const [isSocialMediaDataCollapsed, setIsSocialMediaDataCollapsed] =
    useState(true);

  // Define statusMap in the provider
  const statusMap = {
    "-3": { text: "Crawling Failed ❌", color: "darkred" },
    "-2": { text: "No Data Found ⚠️", color: "gray" },
    0: { text: "Extracting Data.....", color: "blue" },
    1: { text: "Crawling Complete", color: "green" },
    2: { text: "Queued", color: "red" },
    3: { text: "Running Analysis.....", color: "orange" },
    4: { text: "Analysis Complete", color: "purple" },
  };

  const [applyValue, setApplyValue] = useState("filter");
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
  const [isSubMenuOpen2, setIsSubMenuOpen2] = useState(false);
  const [isSubMenuOpen3, setIsSubMenuOpen3] = useState(false);
  const [isSubMenuOpen4, setIsSubMenuOpen4] = useState(false);
  const [dateTimeRange, setdateTimeRange] = useState("30d");
  const [selectedRange, setSelectedRange] = useState(7); // Default is 7 days
  const [searchValue, setsearchValue] = useState("");
  const [activeBtn, setActiveBtn] = useState("30d");
  const rangeValues = [7, 15, 30, 90];
  const [collapsed, setCollapsed] = useState(false);
  const [platformWiseFilterData, setplatformWiseFilterData] = useState([]);
  const [sentimentData, setSentimentData] = useState([]);
  //DATE MODAL
  const [newDate, setNewDate] = useState([
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ]);
  const [dashboardDate, setDashboardDate] = useState(null);
  const [reportfromDateTimeFormatted, setreportFromDateTimeFormatted] =
    useState(null);
  const [reporttoDateTimeFormatted, setreportToDateTimeFormatted] =
    useState(null);

  const [topicOpen, setTopicOpen] = useState(false);

  const [isDownload, setIsDownload] = useState(false);
  const [captchaData, setCaptchaData] = useState({
    captcha: "",
    captchaId: "",
  });
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [showDialog, setShowDialog] = useState(false);

  const [sentimentSummary, setsentimentSummary] = useState([]);
  const [fakeNewsLoading, setfakeNewsLoading] = useState(false);

  const [formData, setFormData] = useState({
    topic: "",
    description: "",
    toggle: false,
    type: "",
    platforms: [],
  });
  const values = {
    setIsSubMenuOpenDataHub,
    isSubMenuOpenDataHub,
    availablePlatforms,
    setAvailablePlatforms,
    toggleButton,
    settoggleButton,
    serverresponses,
    setServerResponses,
    serverresponse,
    setServerResponse,
    analyticsData,
    setAnalyticsData,
    apiSelect,
    setAPISelect,
    fromDateTime,
    setFromDateTime,
    toDateTime,
    setToDateTime,
    isLoading,
    setIsLoading,
    isCompleted,
    setIsCompleted,
    pdfToSimple,
    setpdfToSimple,
    pdfFromSimple,
    setpdfFromSimple,
    // Provide new state variables
    selectedPlatforms,
    setSelectedPlatforms,
    selectedKeyword,
    setSelectedKeyword,
    selectedSections,
    setSelectedSections,
    selectedLanguages,
    setSelectedLanguages,
    selectedSentiment,
    setSelectedSentiment,
    selectedIntensity,
    setSelectedIntensity,
    selectedContent,
    setSelectedContent,
    fromDateTimeFormatted,
    setFromDateTimeFormatted,
    toDateTimeFormatted,
    setToDateTimeFormatted,
    responseCount,
    setResponseCount,
    toggleAdduser,
    settoggleAdduser,
    filteredCrawledData,
    setfilteredCrawledData,
    togglefilteredCrawledData,
    settogglefilteredCrawledData,
    selectedPlatform,
    setSelectedPlatform,
    currentPage,
    setCurrentPage,
    viewMode,
    setViewMode,
    isLoadings,
    setIsLoadings,
    keywordInput,
    setKeywordInput,
    selectedPlatformss,
    setselectedPlatformss,
    postCount,
    setPostCount,
    isSpecificDateEnabled,
    setIsSpecificDateEnabled,
    dateWiseData,
    setDateWiseData,
    openModal,
    setOpenModal,
    sessionData,
    setsessionData,
    data,
    setData,
    itemsPerPage,
    AnalysisSessionData,
    setAnalysisSessionData,
    updateStatus,
    setupdateStatus,
    navigationCount,
    setNavigationCount,
    loading,
    setLoading,
    NewsCount,
    setNewsCount,
    allCrawledData,
    setallCrawledData,
    statusMap,
    sidebarPlatformName,
    setsidebarPlatformName,
    setIsSocialMediaDataCollapsed,
    isSocialMediaDataCollapsed,
    applyValue,
    setApplyValue,
    isSubMenuOpen,
    setIsSubMenuOpen,
    isSubMenuOpen2,
    setIsSubMenuOpen2,
    isSubMenuOpen3,
    setIsSubMenuOpen3,
    isSubMenuOpen4,
    setIsSubMenuOpen4,
    selectedRange,
    setSelectedRange,
    rangeValues,
    dateTimeRange,
    setdateTimeRange,
    searchValue,
    setsearchValue,
    activeBtn,
    setActiveBtn,
    collapsed,
    setCollapsed,
    platformWiseFilterData,
    setplatformWiseFilterData,
    //ModalDate
    newDate,
    setNewDate,
    dashboardDate,
    setDashboardDate,
    reporttoDateTimeFormatted,
    setreportToDateTimeFormatted,
    reportfromDateTimeFormatted,
    setreportFromDateTimeFormatted,
    topicOpen,
    setTopicOpen,
    isDownload,
    setIsDownload,
    captchaData,
    setCaptchaData,
    selectedId,
    setSelectedId,
    dialogOpen,
    setDialogOpen,
    showDialog,
    setShowDialog,
    sentimentData,
    setSentimentData,
    sentimentSummary,
    setsentimentSummary,
    fakeNewsLoading,
    setfakeNewsLoading,
    formData,
    setFormData,
  };

  return <MyContext.Provider value={values}>{children}</MyContext.Provider>;
};

export default MyProvider;
